import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


// GA4
import ReactGA from 'react-ga4';
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (GA_ID) {
  ReactGA.initialize(GA_ID);
  // İlk sayfa yüklenişinde pageview gönder
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
} else {
  if (process.env.NODE_ENV === 'development') {
    console.warn('GA: REACT_APP_GA_MEASUREMENT_ID tanımlı değil.');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
